import React from 'react';

interface SectionHeaderProps {
  icon: React.ReactNode;
  title: string;
  subtitle?: string;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ icon, title, subtitle }) => {
  return (
    <div className="cc-section-header">
      <div className="cc-section-header__icon">
        {icon}
      </div>
      <div className="cc-section-header__text">
        <div className="cc-section-header__title">{title}</div>
        {subtitle && <div className="cc-section-header__subtitle">{subtitle}</div>}
      </div>
    </div>
  );
};

export default SectionHeader;
